// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section .form-row[data-v-ddf579d0] .pagination-wrapper {\n  background-color: #e2e8f3;\n}\n.input-i[data-v-ddf579d0] {\n  padding-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
